import type React from "react"

export const Layout_one: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Layout One</title>
    <path
      d="M4.74023 3.74023C4.18795 3.74023 3.74023 4.18795 3.74023 4.74023V21.1302C3.74023 21.6825 4.18795 22.1302 4.74023 22.1302H16.4545C17.0068 22.1302 17.4545 21.6825 17.4545 21.1302V4.74023C17.4545 4.18795 17.0068 3.74023 16.4545 3.74023H4.74023Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.53247 0H17.6623C19.5942 0 21.1948 1.48295 21.1948 3.27273V22.9091C21.1948 24.75 19.5942 26.1818 17.6623 26.1818H3.53247C1.54545 26.1818 0 24.75 0 22.9091V3.27273C0 1.48295 1.54545 0 3.53247 0ZM17.6623 24.5455C18.6007 24.5455 19.4286 23.8295 19.4286 22.9091V3.27273C19.4286 2.40341 18.6007 1.63636 17.6623 1.63636H3.53247C2.53896 1.63636 1.76623 2.40341 1.76623 3.27273V22.9091C1.76623 23.8295 2.53896 24.5455 3.53247 24.5455H17.6623Z"
      fill={props.fill ?? "#2C1789"}
    />
  </svg>
)
